import React, {useState} from 'react';
import {Box} from "@mui/material";
import style from "./calendarList/CalendarList.module.css";
import DaysList from "./DaysList";
import {months} from "../common/helper";
import {getAllDaysInMonth} from "../common/getAllDaysInMonth";

type Props = {
    portion: Date[],
    setPortion(date: Date[]): void
}

const Days: React.FC<Props> = React.memo(({portion, setPortion}) => {
    // 👇️ all days of the current month
    const now = new Date();
    const days = getAllDaysInMonth(now.getFullYear(), now.getMonth(), now.getMonth() + 1, now);
    const [isPortionOne, setPortionOne] = useState(false)
    const handleSetPortionOne = () => {
        setPortion(days.slice(0, 22))
        setPortionOne(false)
    }
    const handleSetPortionTwo = () => {
        setPortion(days.slice(22, 44))
        setPortionOne(true)
    }

    return (
        <Box className={style.days2}>
            {isPortionOne && <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "90px",
                backgroundColor: "primary.main",
                opacity: 0.5,
                color: "secondary.light",
                cursor: "pointer",
                position: "absolute",
                borderRadius: "2px",
                '&:hover': {
                    opacity: 0.9,
                    boxShadow: "2px 0px 5px #5BA0CE",
                }
            }}
                                  onClick={handleSetPortionOne}>
                {"<"}
            </Box>}
            {!isPortionOne && <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "90px",
                backgroundColor: "primary.main",
                opacity: 0.5,
                color: "secondary.light",
                cursor: "pointer",
                position: "absolute",
                borderRadius: "2px",
                right: 0,
                '&:hover': {
                    opacity: 0.9,
                    boxShadow: "-2px 0px 5px #5BA0CE",
                }
            }}
                                   onClick={handleSetPortionTwo}>
                {">"}
            </Box>}
            {portion.map((day, ind) => {
                return <div key={ind} style={{flexGrow: 1}}>
                    {/*{ind}*/}
                    <DaysList weekDay={day.getDay()} dayNum={day.getDate()} id={ind} month={months[day.getMonth()]}/>
                </div>
            })}

        </Box>
    )
})

export default Days;